import React, { useRef, useState } from "react";

import { View, FlatList, Platform } from "react-native";
import {
  Empty,
  Error,
  Header,
  Loading,
  OrderCard,
  InfinityList,
  Text,
  Button,
  Separator,
} from "component";

import { colors, sizes, strings } from "asset/constant";
import { css } from "style";
import { mq, sn } from "utils";

import { useFactors } from "client/api";
import { QuickFiltersT, quickFiltersData } from "./quickFiltersData";

const viewOffset = sizes.screenW / 2 - mq(40);
const QuickFilterSeparator = () => (
  <Separator sidesSpace={mq(2)} axis="y" color="transparent" />
);

export default function Orders() {
  const [quickFilter, setQuickFilter] = useState<QuickFiltersT>(
    quickFiltersData[0]
  );
  const {
    data,
    error,
    isError,
    refetch,
    isLoading,
    hasNextPage,
    isRefetching,
    fetchNextPage,
    isFetchingNextPage,
  } = useFactors({ quickFilters: quickFilter.value });

  const tabs = useRef<FlatList>(null);

  const _renderCategory = (params: {
    item: { id: number; title: string; value: string };
    index: number;
  }) => {
    const { item, index } = params;
    const active = quickFilter.id === item.id;
    return (
      <Button
        onPress={() => {
          tabs.current?.scrollToIndex({ index, animated: true, viewOffset });
          setQuickFilter(item);
        }}
        style={{
          borderWidth: mq(1),
          borderColor: active ? colors.theme : colors.border.light,
        }}
        height={mq(27)}
        width="auto"
        bgColor={active ? colors.theme : colors.white}
        renderContent={() => {
          return (
            <View
              style={{
                paddingVertical: mq(3),
                paddingHorizontal: mq(10),
                ...css.rRowCenterAlign,
              }}
            >
              <Text
                weight="bold"
                color={active ? colors.white : colors.text.normal}
                {...(Platform.OS === "web"
                  ? { top: sn(2, 3, 4, 5) }
                  : { style: { bottom: mq(2), marginRight: mq(3) } })}
              >
                {item.title}
              </Text>
            </View>
          );
        }}
      />
    );
  };

  const _renderItem = (items: []) => {
    return (
      <View style={{ ...css.wrap, ...css.rRowCenterAlignSpaceBetween }}>
        {items?.map((order: FactorT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <OrderCard key={String(key)} order={order} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.length === 0) {
      return (
        <Empty
          style={{ minHeight: mq(100) }}
          message={strings.not_any_item_to_show}
        />
      );
    }

    return (
      <InfinityList
        onRefresh={refetch}
        renderItemList={_renderItem}
        responseData={data}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        paddingBottom={mq(60)}
      />
    );
  };

  return (
    <>
      <Header title={strings.orders} />

      <View style={{ ...css.container }}>
        <View>
          <FlatList
            keyExtractor={(_, key) => String(key)}
            ref={tabs}
            inverted
            horizontal
            showsHorizontalScrollIndicator={false}
            ItemSeparatorComponent={QuickFilterSeparator}
            contentContainerStyle={{
              ...css.paddingH,
              ...css.growContainer,
              ...css.centralElements,
              marginTop: mq(10),
              marginBottom: mq(3),
            }}
            data={quickFiltersData}
            renderItem={_renderCategory}
          />
        </View>
        {_renderContent()}
      </View>
    </>
  );
}
